<template>
  <div>
    <b-button v-show="showBtn"
              v-b-modal="`modal-${propUrl}`"
              variant="outline-primary btn-sm"
              @click="acessarQRCode(propUrl)">
      QR Code
    </b-button>

    <b-modal :id="`modal-${propUrl}`"
             b-modal
             title="QR Code Selo"
             centered
             size="md">
      <div class="d-block text-center">
        <b-row>
          <b-col>
            <img :src="qrcodeModal">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button class="btn btn-sm btn-primary mr-2"
                    @click="downloadQrcode()">
              <icon-svg icon="fileDownload"
                        class="icon--xs icons--white" />
              Baixar imagem
            </button>
            <b-button v-b-tooltip.click
                      class="btn-sm"
                      variant="primary"
                      title="URL do QRCode copiada!"
                      @click="copyQrcodeUrl">
              Copiar URL
            </b-button>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer="{ ok }">
        <b-button size="sm"
                  variant="secondary"
                  @click="ok(), runDisable()">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

  <script>

  import qrcode from 'qrcode'


  export default ({
    name: 'BoxOsModalQrCode',
    props: {
      propRegistro: { type: Object, default: () => { return {} }},
      propUrl: { type: String, default: ''},
      propRun: { type: Boolean, default: false},
      showBtn: { type: Boolean, default: true}
    },
    data () {
      return {
        urlQrcodeModal: null,
        qrcodeModal: null
      }
    },
    watch: {
      getQrCode () {

      },
      propRun () {
        this.acessarQRCode(this.propUrl)
      }
    },
    methods: {
      async acessarQRCode (qrCodeUrl) {
        this.urlQrcodeModal = qrCodeUrl
        const result = await qrcode.toDataURL(qrCodeUrl)
        this.qrcodeModal = result
      },
      runDisable () {
        this.$emit('runDisable')
      },
      downloadQrcode () {
        let link = document.createElement("a")
        link.download = `qrcode_${this.propRegistro.matricula}`
        link.href = this.qrcodeModal
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      copyQrcodeUrl () {
        navigator.clipboard.writeText(this.urlQrcodeModal)
      },
    }
  })
</script>
